import { X } from 'lucide-react';
import { useBonusPackSelectionStore } from '../../stores/bonusPackSelectionStore';
import { c } from '../../styles/theme';

export default function SelectedBonusPacks() {
  const voicePacks = useBonusPackSelectionStore((state) => state.voicePacks);
  const samplePack = useBonusPackSelectionStore((state) => state.samplePack);
  const removePack = useBonusPackSelectionStore((state) => state.removePack);
  const selected = [...voicePacks, ...(samplePack ? [samplePack] : [])];

  if (selected.length === 0) return null;

  return (
    <div
      aria-label="Selected bonus packs"
      style={{ display: 'flex', flexWrap: 'wrap', gap: 7, marginBottom: 10 }}
    >
      {selected.map((pack) => (
        <div
          key={`${pack.kind}-${pack.bonusId}-${pack.entryIndex}`}
          title={pack.title}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            minWidth: 0,
            maxWidth: 210,
            height: 30,
            paddingLeft: 10,
            border: `1px solid ${c.accentBorder}`,
            borderRadius: 6,
            background: c.accentSoft,
            color: c.text1,
            boxSizing: 'border-box',
          }}
        >
          <span
            style={{
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontSize: 11.5,
              lineHeight: '28px',
            }}
          >
            {pack.title}
          </span>
          <button
            type="button"
            aria-label={`Remove ${pack.title}`}
            onClick={() => removePack(pack.kind, pack.bonusId, pack.entryIndex)}
            style={{
              width: 30,
              height: 28,
              marginLeft: 'auto',
              padding: 0,
              border: 0,
              background: 'transparent',
              color: c.text2,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              flexShrink: 0,
            }}
          >
            <X size={13} aria-hidden="true" />
          </button>
        </div>
      ))}
    </div>
  );
}
